const GoSquaredChatButtonSelector = '#gs *';
const GoSquaredInputParentSelector = '#gs .gs3r';
let goSquaredStyle: HTMLStyleElement | null = null;

export default function useToggleGoSquaredChatButton() {
  // Issue with prior implementation: as goSquared chat button gets rendered after app is mounted,
  // trying to hide it on mount will not work.
  // hideOnMount: flag indicating whether to hide the chat button on mount, will hide all go squared elementss
  const hideGoSquaredChatButton = (hideOnMount: boolean = false) => {
    if (hideOnMount) {
      goSquaredStyle = document.createElement('style');
      goSquaredStyle.innerHTML = `${GoSquaredChatButtonSelector} { z-index: -10 !important; }`;
      document.head.appendChild(goSquaredStyle);
      return;
    }

    const chatButton = document.querySelector<HTMLElement>(GoSquaredChatButtonSelector);
    if (chatButton) {
      chatButton.style.zIndex = '-10';
      chatButton.style.position = 'absolute';
    }
  };

  const showGoSquaredChatButton = (hiddenOnMount: boolean = false) => {
    if (hiddenOnMount) {
      if (goSquaredStyle?.parentNode) {
        goSquaredStyle.parentNode.removeChild(goSquaredStyle);
      }
      return;
    }

    const chatButton = document.querySelector<HTMLElement>(GoSquaredChatButtonSelector);
    if (chatButton) {
      chatButton.style.zIndex = '';
      chatButton.style.position = '';
    }
  };

  const isEventTargetGoSquaredInput = (event: Event) => {
    const target = event.target as HTMLElement;
    return target?.closest?.(GoSquaredInputParentSelector) != null;
  };

  return {
    hideGoSquaredChatButton,
    showGoSquaredChatButton,
    isEventTargetGoSquaredInput,
    GoSquaredChatButtonSelector,
  };
}
